import * as React from 'react';
import { ModuleProps } from 'src/utils/module-util';
import { ComponentLayout } from 'src/components/common/modules/component-layout/code-split/component-layout-component';
import { ComponentLayoutType } from 'src/components/common/modules/component-layout/component-layout';
import { ImageCarouselComponent } from 'src/components/common/modules/v1/image-carousel/code-split/image-carousel-component';

// Css Style Import
import(/* webpackChunkName: "v1-image-carousel-styles" */ 'src/components/common/modules/v1/image-carousel/styles/image-carousel.css');

const ImageCarouselModule = (props: ModuleProps) => {
  const componentLayoutType: ComponentLayoutType<any> = {
    moduleName: 'imageCarouselModule',
    data: {
      ...props,
    },
  };
  return (
    <ComponentLayout {...componentLayoutType}>
      <ImageCarouselComponent />
    </ComponentLayout>
  );
};

export { ImageCarouselModule };
